import {gql} from '@apollo/client';
import {GOAL, OV_RECOMMENDATION, POT} from '../../graphql/fragments';

export const LIST_GOALS = gql`
  ${GOAL}
  query ListGoals($accountId: UUID!, $reviewId: UUID, $hideNoLongerRequired: Boolean) {
    goals(
      accountId: $accountId
      reviewId: $reviewId
      hideNoLongerRequired: $hideNoLongerRequired
    ) {
      ...Goal
    }
  }
`;

export const CREATE_GOAL = gql`
  ${GOAL}
  mutation CreateGoal($accountId: UUID!) {
    createGoal(accountId: $accountId) {
      ok
      goal {
        ...Goal
      }
    }
  }
`;
export const CHECK_DELETE_GOAL_DETAILS = gql`
  ${GOAL}
  ${OV_RECOMMENDATION}
  query CheckDeleteGoalDetails($goalId: UUID!) {
    goalDetails(goalId: $goalId) {
      ...DeleteGoalDetails
    }
  }

  fragment DeleteGoalDetails on GoalType {
    ...Goal
    ovrecommends {
      ...OVRecommendation
    }
  }
`;

export const DELETE_GOAL = gql`
  mutation DeleteGoal($goalId: UUID!) {
    deleteGoal(goalId: $goalId) {
      ok
      goalId
    }
  }
`;

export const UPDATE_GOAL = gql`
  ${GOAL}
  mutation UpdateGoal(
    $goalId: UUID!
    $name: String
    $position: Int
    $priority: String
    $targetIncome: Decimal!
    $targetCapital: Decimal!
    $targetEndDate: DateTime
    $statusAtReview: StatusAtReviewEnum
    $ownership: String
    $contactId: UUID
    $secondaryContactId: UUID
    $description: String
    $drawdownRate: Decimal!
    $planningObjective: String
    $planningObjectivePurpose: String
    $targetAge: Int
    $targetYears: Int
    $reviewId: UUID
    $objectiveType: String
    $goalType: String
  ) {
    updateGoal(
      goalId: $goalId
      name: $name
      position: $position
      priority: $priority
      targetIncome: $targetIncome
      targetCapital: $targetCapital
      targetEndDate: $targetEndDate
      statusAtReview: $statusAtReview
      ownership: $ownership
      contactId: $contactId
      secondaryContactId: $secondaryContactId
      description: $description
      drawdownRate: $drawdownRate
      planningObjective: $planningObjective
      planningObjectivePurpose: $planningObjectivePurpose
      targetAge: $targetAge
      targetYears: $targetYears
      reviewId: $reviewId
      objectiveType: $objectiveType
      goalType: $goalType
    ) {
      ok
      goal {
        ...Goal
      }
    }
  }
`;

export const GET_GOAL_DATA = gql`
  ${GOAL}
  ${POT}
  query AllPotsAndGoals($accountId: UUID!) {
    pots(accountId: $accountId) {
      ...Pot
    }
    goals(accountId: $accountId) {
      ...Goal
    }
  }
`;

export const GET_PRIORITIES = gql`
  query GetCuroCodesPriorities {
    getCuroCodes(field: "priority", entity: "t4a_planningobjective") {
      id
      value
    }
  }
`;

export const GET_STATUS_AT_REVIEW = gql`
  query GetCuroCodes {
    getCuroCodes(field: "status_at_review", entity: "t4a_planningobjective") {
      id
      value
    }
  }
`;

export const GET_CONTACTS = gql`
  query GetGoalContacts($accountId: UUID!) {
    goalContacts(accountId: $accountId) {
      id
      name
      simplifiedName
      isMinor
      isVulnerable
      accountContacts {
        account {
          name
        }
      }
    }
  }
`;

// TODO(nino): merge withdrawal reason with product providers + products matrix
export const GET_PRODUCTS = gql`
  query GetProducts($providerId: UUID, $productType: String) {
    products(providerId: $providerId, productType: $productType) {
      id
      name
      formattedName
      acronym
      productBasis
      reportName
      state
    }
  }
`;

// TODO(nino): merge withdrawal reason with product providers + products matrix
export const GET_PRODUCT_PROVIDERS = gql`
  query GetProductProviders(
    $accountId: UUID
    $productType: String
    $productBasis: String
  ) {
    productProviders(
      accountId: $accountId
      productType: $productType
      productBasis: $productBasis
    ) {
      id
      name
      formattedName
      isBank
      isFavourite
      isPanel
      providerType
      rmarCategory
      state
      showMandateSelector
    }
    subplanProductProvders: productProviders(accountId: $accountId, productType: "sub") {
      id
      name
      formattedName
      isBank
      isFavourite
      isPanel
      providerType
      rmarCategory
      state
      showMandateSelector
    }
  }
`;

// TODO(nino): merge with product providers + products matrix
export const GET_WITHDRAWAL_REASON = gql`
  query GetWithdrawalReason {
    getCuroCodes(field: "withdrawal_reason", entity: "t4a_curoholding") {
      id
      value
    }
  }
`;

export const GET_OBJECTIVE_TYPES = gql`
  query getObjectives {
    getCuroCodes(field: "objective_type", entity: "t4a_planningobjective") {
      id
      value
    }
  }
`;

export const SUBMIT_GOAL_TO_CURO = gql`
  mutation SubmitGoal($goalId: UUID!) {
    submitGoal(goalId: $goalId) {
      ok
      goal {
        id
        curoId
        name
      }
    }
  }
`;
